var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v(" About Me ")]),_c('hr'),_c('div',{staticStyle:{"padding-left":"10px"}},[_c('About')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }